import React from 'react';
import './GooglePlayButton.css';

const GooglePlayButton = () => {
    return (
        <a
            href="https://play.google.com/store/apps/details?id=com.hanziflashcards"
            target="_blank"
            rel="noopener noreferrer"
            className="google-play-button"
        >
            <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                className="google-play-badge"
            />
        </a>
    );
};

export default GooglePlayButton;
